import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import { DomSanitizer } from '@angular/platform-browser';

interface IMapsPanelData {
  mapPicker: IUProperty<string>;
}

@Component({
  selector: 'app-maps-panel',
  templateUrl: './maps-panel.component.html',
  styleUrls: ['./maps-panel.component.less']
})
export class MapsPanelComponent {
  @Input() data: IMapsPanelData;
  strHTML: any;

  constructor(private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.assembleHTML();
  }
  
  assembleHTML() {
    this.strHTML = this._sanitizer.bypassSecurityTrustHtml(this.data.mapPicker.value);
  }

}
